import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const ManageSampleAvatarPage = styled.div`
  width: 100%;
  height: 100%;
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
  }
  .button-group{
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
  .fAgWDa .ant-table-content{
    overflow-x: unset;
  }
  .fAgWDa{
    overflow-x: unset;
  }
  .dtr-data{
    white-space: break-spaces;
  }
  .delete-button{
    margin-left:5px;
  }
`;

export default WithDirection(ManageSampleAvatarPage);